import { render, staticRenderFns } from "./DonationMain.vue?vue&type=template&id=67ccd68a&"
import script from "./DonationMain.vue?vue&type=script&lang=js&"
export * from "./DonationMain.vue?vue&type=script&lang=js&"
import style0 from "./DonationMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports